/**
 * LegalPage - Public Privacy Policy (/privacy) and Terms of Service (/terms)
 * The footer and the client consent screen link here, so these must stay reachable without login.
 */

import React from 'react';
import { LEGAL_ENTITY, LAST_UPDATED, PRIVACY_SECTIONS, TERMS_SECTIONS } from './legalContent';

const PAGES = {
  privacy: { title: 'Privacy Policy', sections: PRIVACY_SECTIONS },
  terms: { title: 'Terms of Service', sections: TERMS_SECTIONS },
};

const s = {
  page: { minHeight: '100vh', backgroundColor: '#0A0F1D', color: '#FFFFFF', padding: '48px 20px' },
  inner: { maxWidth: 760, margin: '0 auto' },
  logo: { fontSize: 22, fontWeight: 800, marginBottom: 32 },
  logoAccent: { color: '#0057FF' },
  title: { fontSize: 28, fontWeight: 700, marginBottom: 8 },
  updated: { fontSize: 13, color: '#8B92A5', marginBottom: 32 },
  heading: { fontSize: 17, fontWeight: 600, marginTop: 28, marginBottom: 8 },
  body: { fontSize: 14, color: '#BBBEC7', lineHeight: 1.8 },
  footer: { fontSize: 12, color: '#5A6175', marginTop: 48 },
  link: { color: '#3B82F6' },
};

export default function LegalPage({ page }) {
  const { title, sections } = PAGES[page] || PAGES.privacy;

  return (
    <div style={s.page}>
      <div style={s.inner}>
        <div style={s.logo}>
          Talk <span style={s.logoAccent}>Australia</span>
        </div>
        <h1 style={s.title}>{title}</h1>
        <div style={s.updated}>Last updated {LAST_UPDATED}</div>

        {sections.map((section) => (
          <section key={section.heading}>
            <h2 style={s.heading}>{section.heading}</h2>
            <p style={s.body}>{section.body}</p>
          </section>
        ))}

        <div style={s.footer}>
          &copy; {new Date().getFullYear()} {LEGAL_ENTITY.shortName}, trading as Talk Australia. ABN {LEGAL_ENTITY.abn}.{' '}
          <a href={page === 'terms' ? '/privacy' : '/terms'} style={s.link}>
            {page === 'terms' ? 'Privacy Policy' : 'Terms of Service'}
          </a>
        </div>
      </div>
    </div>
  );
}
